import createVueComponent from '../createVueComponent';

const Tv2 = createVueComponent('Tv2Icon', [
  ['path', { d: 'M7 21h10', key: '1b0cd5' }],
  [
    'rect',
    { width: '20', height: '14', x: '2', y: '3', rx: '2', key: '48i651' },
  ],
]);

export default Tv2;
